import { _decorator, Node } from 'cc';
import SceneManager from '../../../common/scripts/SceneManager';

const { ccclass, property } = _decorator;

@ccclass('TableSceneManager')
export default class TableSceneManager extends SceneManager {
    @property(Node)
    public readonly debuggerRoot: Node = null;
}
